import { render, staticRenderFns } from "./ab-tab.vue?vue&type=template&id=dc7231d0&scoped=true"
import script from "./ab-tab.vue?vue&type=script&lang=js"
export * from "./ab-tab.vue?vue&type=script&lang=js"
import style0 from "./ab-tab.vue?vue&type=style&index=0&id=dc7231d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7231d0",
  null
  
)

export default component.exports